import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomTable from '../../components/Shared/CustomTable'
import PageHeader from '../../components/Shared/PageHeader'

export default function ViewVendorPage() {
  const location = useLocation()
  const { t } = useTranslation()
  const vendor = location?.state?.vendor || null

  const columns = [
    { field: 'name', header: t('name') },
    { field: 'name_ar', header: t('name_ar') },
    { field: 'vat_no', header: t('vatNo') },
    { field: 'cr_no', header: t('crNo') },
    { field: 'email', header: t('email') },
    { field: 'phone', header: t('contact') },
    { field: 'city', header: t('city') },
    { field: 'country', header: t('country') },
    { field: 'postal_code', header: t('postal_code') },
    { field: 'address', header: t('address') }
  ]

  if (!vendor) {
    return (
      <div>
        <PageHeader title={t('vendor_details')} backPath={'/manager/vendor'} />
        <p className='mt-4'>{t('No_vendor_selected')}</p>
        <div className='mt-4'></div>
      </div>
    )
  }

  const data = [vendor]

  return (
    <div>
      <PageHeader title={t('vendor_details')} backPath={'/manager/vendor'} />
      <CustomTable data={data} columns={columns} rows={1} />
    </div>
  )
}
